import React, { useState } from 'react';
import { makeStyles, Typography, Divider, Box } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
  question: {
    color: '#1a3d5d',
    fontWeight: '700',
    marginBottom: '10px',
    fontSize: '15px',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  divider: {
    marginBottom: '20px'
  },
  cardContent: {
    flexGrow: 1
  }
}));

const FAQSQuestion = ({ question, handleAnswer }) => {
  const classes = useStyles();

  return (
    <Box key={question.id} onClick={() => handleAnswer()}>
      <Typography
        className={classes.question}
        color="textSecondary"
        gutterBottom
      >
        {question.question}
      </Typography>
      <Typography className={classes.answer} color="textSecondary" gutterBottom>
        {question.answer}
      </Typography>
      {question.id != 5 && <Divider className={classes.divider} />}
    </Box>
  );
};

export default FAQSQuestion;
